'use client'

import { Button, Result } from 'antd'
import { useTranslations } from 'next-intl'
import React from 'react'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('錯誤:', error)
    console.error('錯誤資訊:', errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback error={this.state.error} />
    }

    return this.props.children
  }
}

const ErrorFallback = ({ error }: { error?: Error }) => {
  const t = useTranslations()
  console.error('錯誤:', error)
  return (
    <Result
      status='error'
      title={t('error.title')}
      subTitle={t('error.description')}
      extra={[
        <Button
          type='primary'
          key='refresh'
          onClick={() => window.location.reload()}
          className='bg-[#FF3C8E] hover:bg-[#FF3C8E]/80'
        >
          {t('error.refresh')}
        </Button>,
      ]}
    />
  )
}
